import { Pipe, PipeTransform } from "@angular/core";
import { PendingOrderStatus } from "../constants";

@Pipe({
  name: "statusColor",
})
export class StatusColorPipe implements PipeTransform {
  transform(value: any): any {
    switch (value) {
      case PendingOrderStatus.AwaitingPaymentConfirmation:
        return "badge badge-danger";
        // return "label-info";
        break;
      case PendingOrderStatus.PaymentConfirmed:
        return "badge badge-info";
        // return "label-info";
        break;
      case PendingOrderStatus.TruckNotimation:
        return "badge badge-primary";
        // return "label-info";
        break;
      case PendingOrderStatus.Released:
        return "badge badge-info";
        // return "label-info";
        break;
      case PendingOrderStatus.Cancelled:
        return "badge badge-muted";
        // return "label-info";
        break;
      case PendingOrderStatus.Refunded:
        return "badge badge-success";
        // return "label-info";
        break;
      case PendingOrderStatus.Completed:
        return "badge badge-success";
        // return "label-info";
        break;
    }
    return null;
  }
}
